module.exports = __webpack_public_path__ + "static/media/20190826_175638.image.d6689749.png";